module.exports = __webpack_public_path__ + "img/avatar-s-3.a718f09a.png";